module.exports = __webpack_public_path__ + "static/media/preview.7945bd84.svg";